import styles from '../../styles/products.module.css';
import SectionTitle from '../common/SectionTitle';
import { IMAGEPATH } from '../../constants/imagePath';
import { ICONPATH } from '../../constants/iconPath';
import ProductDeliveryRobotBoxTitle from './ProductDeliveryRobotBoxTitle';
import ProductDeliveryRobotBoxDetail from './ProductDeliveryRobotBoxDetail';
import ServiceCases from '../common/ServiceCases';
import { KR } from '../../constants/localizations';
import ProductRobotDetailWrap from './ProductRobotDetailWrap';
import ProductDeliveryRobotCaseItem from './ProductDeliveryRobotCaseItem';
import ProductDeliveryRobotCardMini from './ProductDeliveryRobotCardMini';
import ProductDeliveryRobotCardSeu from './ProductDeliveryRobotCardSeu';

export default function ProductDeliveryRobot() {
    return (
        <div className={styles.robotD}>
            <div className={styles.robotFlexGap}>
                <SectionTitle title={KR.label_products_delivery_robot} titleEng={KR.label_products_delivery_robot_eng} />
                {/* 배로미 */}
                <ProductRobotDetailWrap image={IMAGEPATH.baeromi} imageWebp={IMAGEPATH.baeromiWebp} titleComponent={<ProductDeliveryRobotBoxTitle title={KR.label_products_delivery_baeromi} content={KR.label_products_delivery_baeromi_detail} />}
                    detailComponent={<ProductDeliveryRobotBoxDetail />} />
            </div>
            {/* 서비스 활용 예시 */}
            <div className={styles.caseW}>
                <ServiceCases title={"서비스 활용 예시"} titleEng={"Service Use Cases"} />
                <div className={styles.caseWrapDelivery}>
                    <ProductDeliveryRobotCaseItem title={"아울렛, F&B 등"} title2={"배송 서비스"} icon={ICONPATH.delivery} />
                    <ProductDeliveryRobotCaseItem title={"캠퍼스, 도서관"} title2={"물품 이동 서비스"} icon={ICONPATH.boxH} />
                    <ProductDeliveryRobotCaseItem title={"순찰 로봇"} icon={ICONPATH.checkListW} />
                </div>
            </div>
            {/* 배로미 미니, 스스로 */}
            <div className={styles.robotMSBox}>
                <ProductDeliveryRobotCardMini />
                <ProductDeliveryRobotCardSeu />
            </div>

        </div>
    )
}
